module.exports = __webpack_public_path__ + "static/google-play-badge_de-9948ec346d6e1046d4a40c5515e73a03.svg";